import { useQuery } from '@tanstack/react-query';

import { IAllUniversitiesRes } from '../models';
import { getAllUniversities } from '../queries/all-universities';
import { universitiesConst } from '..';

export const useAllUniversities = ({
  search,
  page,
  addressId,
  type,
  size = 12
}: {
  search?: string;
  page?: string | string[];
  addressId?: string | string[];
  type?: string | string[];
  size?: number;
}) => {
  const { data: universities, ...args } = useQuery<IAllUniversitiesRes>({
    queryKey: [universitiesConst.queryKeys.ALL_UNIVERSITIES, { page, addressId, type, search, size }],
    queryFn: getAllUniversities({ page, addressId, type, search, size })
  });

  return { universities, ...args };
};
